import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import ContrastRoundedIcon from '@mui/icons-material/ContrastRounded';
import { useThemeModeStore } from './themeModeStore';
import type { ThemeMode } from './createAppTheme';

const OPTIONS: { value: ThemeMode; label: string; icon: JSX.Element }[] = [
  { value: 'light', label: 'Jasny', icon: <LightModeRoundedIcon fontSize="small" /> },
  { value: 'dark', label: 'Ciemny', icon: <DarkModeRoundedIcon fontSize="small" /> },
  { value: 'high-contrast', label: 'Wysoki kontrast', icon: <ContrastRoundedIcon fontSize="small" /> },
];

export function ThemeModeSwitcher() {
  const { mode, setMode } = useThemeModeStore();

  return (
    <ToggleButtonGroup
      value={mode}
      exclusive
      size="small"
      onChange={(_e, next: ThemeMode | null) => {
        if (next) setMode(next);
      }}
      aria-label="Wybierz motyw kolorystyczny"
      sx={{
        '& .MuiToggleButton-root': {
          border: 0,
          px: 1,
          height: 32,
          minHeight: 32,
          borderRadius: 1,
          color: 'text.secondary',
          '&.Mui-selected': {
            backgroundColor: (t) => t.palette.action.selected,
            color: 'primary.main',
          },
          '&:not(:first-of-type)': { ml: 0.25 },
        },
      }}
    >
      {OPTIONS.map((opt) => (
        <ToggleButton key={opt.value} value={opt.value} aria-label={opt.label}>
          <Tooltip title={opt.label}>{opt.icon}</Tooltip>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
